import React from 'react';
import { SingleCheckbox, ButtonLink } from '@youngcapital/component-library';
import { Trans } from 'react-i18next';
import { validTermsResponse, validMinimumAge } from '@youngcapital/validations';
import { asFieldset, FIELDSET_PROPTYPES } from '../asFieldset';
import getCurrentDateTime from '../../helpers/getCurrentDateTime';

const TERMS_LABEL = (
  <Trans i18nKey='fieldset_terms_of_service.terms_of_service_label'>
    contentPlaceholder
    <ButtonLink
      type='button'
      data-toggle='modal'
      data-target='#privacyStatement'
      data-keyboard='true'
      title='privacy-statement-link'
      onClick={e => e.preventDefault()}
    >
      contentPlaceholder
    </ButtonLink>
    contentPlaceholder
    <ButtonLink
      type='button'
      data-toggle='modal'
      data-target='#privacyDeclaration'
      data-keyboard='true'
      title='privacy-declaration-link'
      onClick={e => e.preventDefault()}
    >
      contentPlaceholder
    </ButtonLink>
    contentPlaceholder
  </Trans>
);

const TermsAgreementFieldset = ({ t, getFieldProps, options = {} }) => (
  <>
    {options.legal_age_checkbox && (
      <SingleCheckbox
        label={t('fieldset_terms_of_service.minimum_age_label')}
        variant='wide'
        {...getFieldProps('legal_age_confirmed', props => ({
          ...props,
          checked: props.value,
          onChange: (_, event) => props.onChange(event),
          onBlur: (_, event) => props.onBlur(event)
        }))}
        isRequired
      />
    )}
    <SingleCheckbox
      label={TERMS_LABEL}
      variant='wide'
      {...getFieldProps('terms_of_service', props => ({
        ...props,
        checked: props.value || false,
        onChange: (_, event) => props.onChange(event),
        onBlur: (_, event) => props.onBlur(event)
      }))}
      isRequired
    />
  </>
);

TermsAgreementFieldset.type = 'terms-agreement';

TermsAgreementFieldset.propTypes = FIELDSET_PROPTYPES;

TermsAgreementFieldset.initialValues = (options = {}) => {
  const legalAgeConfirmation = options.legal_age_checkbox
    ? {
        legal_age_confirmed: false,
        legal_age_confirmed_at: getCurrentDateTime()
      }
    : [];

  const legalAgeValue = options.legal_age_value
    ? { legal_age_value: options.legal_age_value }
    : [];

  return {
    terms_of_service: false,
    ...legalAgeConfirmation,
    ...legalAgeValue
  };
};

TermsAgreementFieldset.validationSchema = (options = {}) => {
  const legalAgeConfirmation = options.legal_age_checkbox
    ? { legal_age_confirmed: validMinimumAge() }
    : [];

  return {
    terms_of_service: validTermsResponse(),
    ...legalAgeConfirmation
  };
};

export default asFieldset(TermsAgreementFieldset);
